import React from "react";
import { Loader } from "@fluentui/react-northstar";
import pl from "../../shared/messages/pl";
import styles from "../PowerBiReportsTab.module.scss";

export const PowerBiReportsInitializingLoader: React.FC = () => (
    <Loader label={pl.powerBiReports.initializingReports} className={styles.loader} />
);
